export default __webpack_public_path__ + "static/media/fotoReinoBurger.7e566f02.png";